export default "__VITE_ASSET__ChI2Fcff__"